import { Stack, StackItem, Tab, Tabs } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ModalSidePanel } from '@mews-commander/ui';
import { AssignUsersTab } from '../AssignUsers';
import { DeleteRoleCell } from '../DeleteRole';
import { EditRoleCell } from '../EditRole';
import { EditRoleTabs, useRoleContext } from '../context';
import { usePortfolioSelectors } from '../utils';
import { RoleMetadata } from './RoleMetadata';
import { PrivilegesList } from './PrivilegesList';

export const RoleDetail = () => {
    const { activeRole, closeRoleDetail, activeTab, setActiveTab } = useRoleContext();
    const { isPortfolio, hasMultiPropertyAccess } = usePortfolioSelectors();

    const handleClose = () => {
        closeRoleDetail();
    };

    if (!activeRole) {
        return null;
    }

    return (
        <ModalSidePanel
            opened
            onClose={handleClose}
            title={activeRole.name}
            headerActions={
                <Stack distribution="space-between" spacing="100">
                    <EditRoleCell variant="tertiary" size="medium" role={activeRole} />
                    <DeleteRoleCell variant="tertiary" size="medium" role={activeRole} onDelete={handleClose} />
                </Stack>
            }
            width="medium"
            content={
                <Stack vertical spacing="300">
                    {isPortfolio && hasMultiPropertyAccess ? (
                        <Tabs
                            activeTabValue={activeTab}
                            inline
                            showDivider
                            onTabClick={(e, value) => setActiveTab(value as EditRoleTabs)}
                        >
                            <Tab
                                key={EditRoleTabs.Settings}
                                label={<LocalizedText textKey={TextKey.Settings} />}
                                value={EditRoleTabs.Settings}
                                id={EditRoleTabs.Settings}
                            />
                            <Tab
                                key={EditRoleTabs.Users}
                                label={<LocalizedText textKey={TextKey.UserPlural} />}
                                value={EditRoleTabs.Users}
                                id={EditRoleTabs.Users}
                            />
                        </Tabs>
                    ) : null}

                    <StackItem>
                        {activeTab === EditRoleTabs.Settings ? (
                            <>
                                <PrivilegesList role={activeRole} />
                                <RoleMetadata role={activeRole} />
                            </>
                        ) : (
                            <AssignUsersTab role={activeRole} />
                        )}
                    </StackItem>
                </Stack>
            }
        />
    );
};
